
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqG49zTqpZg_1aX_ZzzwXdO0H6EfiWoymFrrv9_G_Ewd4Meta } from "/build/pages/faq.vue?macro=true";
import { default as indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta } from "/build/pages/index.vue?macro=true";
import { default as index2AUCahahiu1vFOn5vilxjDwMNcIQBG0zFSuxtXfCmvcMeta } from "/build/pages/vcm/index.vue?macro=true";
import { default as indexEozsLAOxVw_45XduStWsC02XBxBs7HV1xaTQNzA6IpuN8Meta } from "/build/pages/etps/index.vue?macro=true";
import { default as indexdu7xMHJuqFtPbvi5JRkl7EteWj6HmOzRBTDhEa1y1BsMeta } from "/build/pages/news/index.vue?macro=true";
import { default as indexX6EXGW4XPTDXHGeD_KmytLHQvaDwdJxiKR6AOK7MJl8Meta } from "/build/pages/contact/index.vue?macro=true";
import { default as indexRG_45Xpg8eWdFCyvjTA6EHVVgh8YvtdIL_45l7ut2W8t2KsMeta } from "/build/pages/notices/index.vue?macro=true";
import { default as indexW2GZuKEPyKdvoszSBX5XEi__45Xme_5N6zBI2Tbr9vnq8Meta } from "/build/pages/equities/index.vue?macro=true";
import { default as privacy_45noticeVgJYUGH5KrFFW8nsThAxMSvPt1_45zzVbd7jmJm3APjVoMeta } from "/build/pages/privacy-notice.vue?macro=true";
import { default as indexWIF4WGF_TABvvT7kEw269FN4jctPgCmxjx0hylXEbyMMeta } from "/build/pages/artex-mtf/index.vue?macro=true";
import { default as indexc6ckmqG8PgwXr2sZx7glm0phSg_45NYbz487OuE4PSXg4Meta } from "/build/pages/reporting/index.vue?macro=true";
import { default as indexXlSl7sK0l9MwN5tMeI6Q4MDudjYR2KKWd7G5hAWbZJsMeta } from "/build/pages/compliance/index.vue?macro=true";
import { default as indexE9PRpw2_ieCLhj1b7G_ad5MAgbNy8xOSTm0_ryZuFg8Meta } from "/build/pages/how-to-list/index.vue?macro=true";
import { default as indexkoxAKXvnEbwnbkL6OX9fNbaJw_nGBvW48XE_h_2yWbMMeta } from "/build/pages/our-company/index.vue?macro=true";
import { default as terms_45and_45conditionsMsiTuOlaPRAJRU2ZOiZG7o__v52YjQ37XghdSJq6HPIMeta } from "/build/pages/terms-and-conditions.vue?macro=true";
import { default as indexPeiQcovyuw_u2UsPpvXRRQe_W2OAcxIg5FI5aHpKirYMeta } from "/build/pages/trading-information/index.vue?macro=true";
import { default as index1WGi79kQJcb8J9B4ut3LG4mNyttb5N_45CSS1mRSFT_45NkMeta } from "/build/pages/trading-participants/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/build/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/build/pages/index.vue")
  },
  {
    name: "vcm",
    path: "/vcm",
    component: () => import("/build/pages/vcm/index.vue")
  },
  {
    name: "etps",
    path: "/etps",
    component: () => import("/build/pages/etps/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/build/pages/news/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/build/pages/contact/index.vue")
  },
  {
    name: "notices",
    path: "/notices",
    component: () => import("/build/pages/notices/index.vue")
  },
  {
    name: "equities",
    path: "/equities",
    component: () => import("/build/pages/equities/index.vue")
  },
  {
    name: "privacy-notice",
    path: "/privacy-notice",
    component: () => import("/build/pages/privacy-notice.vue")
  },
  {
    name: "artex-mtf",
    path: "/artex-mtf",
    component: () => import("/build/pages/artex-mtf/index.vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/build/pages/reporting/index.vue")
  },
  {
    name: "compliance",
    path: "/compliance",
    component: () => import("/build/pages/compliance/index.vue")
  },
  {
    name: "how-to-list",
    path: "/how-to-list",
    component: () => import("/build/pages/how-to-list/index.vue")
  },
  {
    name: "our-company",
    path: "/our-company",
    component: () => import("/build/pages/our-company/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/build/pages/terms-and-conditions.vue")
  },
  {
    name: "trading-information",
    path: "/trading-information",
    component: () => import("/build/pages/trading-information/index.vue")
  },
  {
    name: "trading-participants",
    path: "/trading-participants",
    component: () => import("/build/pages/trading-participants/index.vue")
  }
]